import { PORTAL_PATH } from "@/layouts/portal/portalNavigation";
import { createFileRoute, redirect } from "@tanstack/react-router";

// Bare path opens the form.
export const Route = createFileRoute("/vendor/consignment-vendor-application/")(
	{
		validateSearch: (search: Record<string, unknown>) => search,
		beforeLoad: () => {
			throw redirect({
				to: PORTAL_PATH.PartnerData,
				search: true,
				replace: true,
			});
		},
	},
);
